import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
//Styling
import styled from "styled-components";

//Import custom components
import toTop from '../../../../features/toTop';

//Import Action
import { filterManufacturer, filterDelivery } from '../../../../../action';

//Import Utils
import { stickyContentHandle, setStickyValues } from '../../../../../utils';

function FiltersMobile(props) {
  const { link = "", filterManufacturer, filterDelivery, filter, manufacturers, cleanFilters, productsCatalog, handleFilters, products } = props;

  const [showClean, setShowClean] = useState(false);

  useEffect(() => {
    setStickyValues(120);
    window.addEventListener('scroll', stickyContentHandle);

    if (filter.manufacturer.length > 0 || filter.delivery) {
      setShowClean(true);
    } else {
      setShowClean(false);
    }

    return () => {
      window.removeEventListener('scroll', stickyContentHandle);
    };
  });

  const getCountManufacturer = (item) => {
    return productsCatalog.filter(product => ((product.manufacturer) ? product.manufacturer.name.indexOf(item) >= 0 : 0)).length;
  };

  const getCountDelivery = (item) => {
    if (item === "locally") {
      if (filter.category || filter.manufacturer) {
        return productsCatalog.length;
      } else {
        return products.length;
      }
    } else if (item === "allCountry") {
      if (filter.category || filter.manufacturer) {
        return productsCatalog.filter(p => p.product_id === 925 || p.product_id === 1133 || p.product_id === 1134).length;
      } else {
        return products.length;
      }
    }
  };

  const getManufacturer = (e, item) => {
    e.preventDefault();
    filterManufacturer(item);
  };

  const getDelivery = (e, item) => {
    e.preventDefault();
    if (getCountDelivery(item) > 0) {
      filterDelivery(item);
    }
  };

  const getFiltering = (e) => {
    e.preventDefault();
    setTimeout(() => {
      toTop();
    }, 100);
    handleFilters();
  };

  const top = () => {
    if (document.querySelector('.sticky-sidebar')) {
      document.querySelector('.sticky-sidebar').style.top = 300 + 'px';
      document.querySelector(".sticky-sidebar").style.opacity = 0;
    }
  };

  const mFilter = manufacturers.sort((a, b) => a.name > b.name).filter(m => getCountManufacturer(m.name) >= 1 ? m : null);

  return (
    <Filters className="mt-3">
      <aside className="sidebar-shop col-auto order-lg-first">
        {
          showClean && (
            <div className="clean-filter">
              <button onClick={cleanFilters}>Wyczyść filtry</button>
            </div>
          )
        }
        {
          link !== "filterTwo" ?
            <>
              <Widget>
                <h3 className="widget-title">
                  <a href="#widget-body-2" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="widget-body-2" onClick={(e) => top}>Producenci</a>
                </h3>
                <div className="collapse show" id="widget-body-2">
                  <div className="widget-body">
                    <ul>
                      {
                        mFilter.map(m => (
                          m.active ? (
                            <li key={m.id}>
                              <input type="checkbox" id={m.id} checked={filter.manufacturer.includes(m.name) ? "checked" : ""} />
                              <label htmlFor={m.id} onClick={(e) => getManufacturer(e, m.name)}>
                                {m.name}&nbsp;
                                <span>({getCountManufacturer(m.name)})</span>
                              </label>
                            </li>
                          )
                            : ""
                        ))
                      }
                    </ul>
                  </div>
                </div>
              </Widget>
              {/* <Widget>
                <h3 className="widget-title">
                  <a href="#widget-body-3" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="widget-body-2" onClick={(e) => top}>Dostawa</a>
                </h3>
                <div className="collapse show" id="widget-body-3">
                  <div className="widget-body">
                    <ul>
                      <li>
                        <input type="checkbox" id="locally" checked={filter.delivery === "locally" ? "checked" : ""} />
                        <label htmlFor="locally" onClick={(e) => getDelivery(e, "locally")}>
                          Lokalnie&nbsp;
                          <span>({getCountDelivery("locally")})&nbsp;&nbsp;</span>
                        </label>
                        <Link to="/info/mapa-zasiegu" target="_blank" className="delivery-maps">mapa dostaw</Link>
                      </li>
                      <li>
                        <input type="checkbox" id="allCountry" checked={filter.delivery === "allCountry" ? "checked" : ""} />
                        <label htmlFor="allCountry" onClick={(e) => getDelivery(e, "allCountry")} style={{color: getCountDelivery("allCountry") === 0 ? "#899296" : "", cursor: getCountDelivery("allCountry") === 0 ? "default" : "pointer"}}>
                          Cała Polska&nbsp;
                          <span>({getCountDelivery("allCountry")})</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </Widget> */}
            </>
            : null
        }
      </aside>
      <Link to="" onClick={(e) => getFiltering(e, {})} className={`show-products${filter.manufacturer.length || filter.delivery ? " active" : ""}`}>POKAŻ PRODUKTY</Link>
    </Filters>
  );
}

const Filters = styled.div`
  position: absolute;
  z-index: 9999;
  background-color: #fff;
  width: 100%;

  .clean-filter {
    font-size: 1.6rem;
    margin-bottom: 1.8rem;
    text-align: right;

    button {
      background-color: transparent;
      border: 0;
      text-transform: uppercase;
      padding: 0;
      color: #ff6a00;
      align-self: end;
      transition: all .3s;

      &:hover {
        color: #002b4f;
      }
    }
  }

  a {

    &.show-products {
      background-color: #c5c5c5;
      pointer-events: none;
      display: block;
      width: 100%;
      color: #fff;
      text-align: center;
      font-weight: 600;
      padding: 2rem 0;
      font-size: 1.8rem;

      &.active {
        background-color: #ff6a00;
        pointer-events: auto;
      }
    }
  }
`;

const Widget = styled.div`
  font-size: 1.6rem;

  h3 > a {
    font-size: 1.6rem!important;
  }

  ul {
    list-style: none;
    line-height: 2;

    span {
      color: #899296;
    }

    input[type=checkbox] {
      display: none;
    }

    input[type=checkbox] + label {
      display: inline;
      background: url("https://buduj.pl/assets/images/checkbox.webp") no-repeat;
      padding: 0 0 0 30px;
      font-size: 1.6rem;
    }

    input[type=checkbox]:checked + label {
      display: inline;
      background: url("https://buduj.pl/assets/images/checkbox_checked.webp") no-repeat;
    }
  }

  .delivery-maps {
    color: #ff6a00;
    font-size: 13px;

    &:hover {
      color: #002b4f;
    }
  }
`;

const mapStateToProps = (state) => {
  return {
    filter: state.filter ? state.filter : [],
    categories: state.categories.categories ? state.categories.categories : [],
    manufacturers: state.manufacturers.manufacturers ? state.manufacturers.manufacturers : []
  };
};

export default connect(mapStateToProps, { filterManufacturer, filterDelivery })(FiltersMobile);